import { Options } from '../../Options'
import { ChartWrapperConstants } from './ChartWrapper.constants'

export const chartWrapperOptions = Options.asRecord(
  Options.createOption({
    key: 'height',
    inputKind: 'number',
    defaultValue: ChartWrapperConstants.defaultHeightPx,
    min: 120,
    max: 900,
    step: 10,
    label: 'Chart height',
    description: 'Total chart host height in pixels (plot + measured padding).',
    category: 'Layout',
  }),
)

export type ChartWrapperOptions = Options.TypeOf<typeof chartWrapperOptions>
